export default __webpack_public_path__ + "static/media/ic_info.7f721eaa.svg";